import React from 'react';
import styled from '@emotion/styled';
import { Flex } from 'rebass';

const StyledThirdPaneContent = styled(Flex)`
  overflow-y: scroll;
  display: flex;
  flex: 1 1 0;
  min-height: 0; /* The secret sauce for inner scrolling */
  flex-direction: column;
`;

export default StyledThirdPaneContent;
